import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { Form, TextArea } from 'react-form';
import Rater from 'react-rater';
import swal from 'sweetalert2';
import { envoyerReaction } from '../../App_Code/API';
import * as Actions from '../../Actions/AdhActions';
import Card from '../Card';

const TOTAL = 5;

class PageReaction extends Component {
    constructor(props) {
        super(props);

        this.envoyerInput = React.createRef();

        this.state = {
            note: undefined,
        };
    }

    componentWillUnmount() {
        if (this.unblock) this.unblock();
    }

    handleRate = (rating, type, id) => {
        if (type === 'click') {
            this.setState({
                [id]: rating,
            });

            if (!this.unblock) {
                this.unblock = this.props.history.block("Vous n'avez pas envoyé votre avis.<br>Voulez-vous vraiment quitter cette page ?");
            }
        }
    };

    handleSubmit = (submittedValues) => {
        const { note } = this.state;
        const { commentaire } = submittedValues;
        this.envoyerInput.current.disabled = true;

        if (note === undefined) {
            swal('Erreur', `Merci de mettre une note globale entre 1 et ${TOTAL}`, 'error');
            this.envoyerInput.current.disabled = false;
            return;
        }

        const XML = `<Note>${note}</Note>`;
        const message = `Note : ${note}/${TOTAL}\n\nCommentaire :\n${commentaire}`;

        envoyerReaction(XML, message).then((response) => {
            if (response && response.status === 200 && response.data > 0) {
                swal('Envoyé', 'Merci de nous avoir laissé votre avis !', 'success');
                if (this.unblock) this.unblock();
                this.props.actions.avisEnvoye();
                this.props.history.push('/');
            } else {
                swal('Erreur', 'Le message n&apos;a pas été envoyé.', 'error');
                this.envoyerInput.current.disabled = false;
            }
        });
    };

    render() {
        const { note } = this.state;
        if (!this.props.PeutLaisserAvis) {
            return (
                <div className="jumbotron text-center">
                    <h1 className="display-4">Vous avez déjà donné votre avis.</h1>
                    <Link to="/">
                        <button className="btn btn-lg btn-secondary mt-3">Retourner vers l&apos;accueil</button>
                    </Link>
                </div>
            );
        }

        return (
            <div className="container">
                <Card Titre="Retour d&apos;information">
                    <div className="alert alert-primary" role="alert">
                        <i className="fas fa-info-circle" /> Votre avis est précieux afin de nous aider à améliorer ce
                        nouvel extranet ! Veuillez, s&apos;il vous plaît, remplir tous les champs de ce formulaire.<br />Ce
                        message sera adressé directement aux développeurs ; merci de ne pas utiliser ce formulaire pour
                        un autre type de demande.
                    </div>
                    <Form onSubmit={this.handleSubmit}>
                        {formApi => (
                            <form onSubmit={formApi.submitForm}>
                                <div className="form-row">
                                    <div className="form-group col-md-3 required">
                                        <label htmlFor="navigation">Note globale</label>
                                    </div>
                                    <div className="form-group col-md-9 required">
                                        <Rater
                                            rating={note}
                                            total={TOTAL}
                                            onRate={({ rating, type }) => this.handleRate(rating, type, 'note')}
                                        />
                                        {note !== undefined && ` ${note}/${TOTAL}`}
                                    </div>
                                </div>
                                <div className="form-group optionnal">
                                    <label htmlFor="commentaire">Commentaire</label>
                                    <TextArea
                                        field="commentaire"
                                        id="commentaire"
                                        className="form-control"
                                        rows="12"
                                        placeholder="Veuillez saisir un message le plus clair possible :&#10;- qu'est-ce qui vous déplaît dans cette interface&#10;- qu'est-ce que vous n'avez pas retrouvé sur cet extranet qui existe sur l'ancien&#10;- qu'est-ce qui pourrait être amélioré&#10;- etc..."
                                    />
                                </div>
                                <div className="form-group text-center">
                                    <button type="submit" className="btn btn-lg btn-success" ref={this.envoyerInput}>
                                        Envoyer votre avis
                                    </button>
                                </div>
                            </form>
                        )}
                    </Form>
                </Card>
            </div>
        );
    }
}

function mapStateToProps({
    AdhStore: {
        Adh: { PeutLaisserAvis },
    },
}) {
    return { PeutLaisserAvis };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(Actions, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(PageReaction);



// WEBPACK FOOTER //
// ./src/components/App/PageReaction.js